<script>
  import { createEventDispatcher } from "svelte";

  export let value = false;
  export let id = null;
  export let name = null;

  let className = $$restProps.class || null;

  const dispatch = createEventDispatcher();

  function handleChange(e) {
    value = !value;
    dispatch("change", value);
  }
</script>

<input
  checked={value}
  {id}
  {name}
  on:change={handleChange}
  autocomplete="off"
  type="checkbox" />

<div class="t-checkbox-icon {className}" />
